(function () {
  function initEdmeFooter(footer) {
    if (!footer || footer.dataset.edmeFooterInit === 'true') return;

    footer.dataset.edmeFooterInit = 'true';

    const forms = footer.querySelectorAll('.edme-footer__form');

    forms.forEach((form) => {
      const checkbox = form.querySelector('.edme-footer__checkbox');
      const button = form.querySelector('.edme-footer__button');

      if (!checkbox || !button) return;

      const updateButtonState = () => {
        if (checkbox.checked) {
          button.removeAttribute('aria-disabled');
        } else {
          button.setAttribute('aria-disabled', 'true');
        }
      };

      updateButtonState();
      checkbox.addEventListener('change', updateButtonState);
    });

    const accordionToggles = footer.querySelectorAll('.edme-footer__accordion-toggle');
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    if (!accordionToggles.length) return;

    const closeColumn = (column, toggle) => {
      column.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    const openColumn = (column, toggle) => {
      column.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    };

    const closeAllColumns = () => {
      accordionToggles.forEach((toggle) => {
        const column = toggle.closest('.edme-footer__column');
        if (!column) return;

        closeColumn(column, toggle);
      });
    };

    const openAllColumnsDesktop = () => {
      accordionToggles.forEach((toggle) => {
        const column = toggle.closest('.edme-footer__column');
        if (!column) return;

        openColumn(column, toggle);
      });
    };

    const syncAccordionMode = () => {
      if (mobileQuery.matches) {
        closeAllColumns();
      } else {
        openAllColumnsDesktop();
      }
    };

    accordionToggles.forEach((toggle) => {
      toggle.addEventListener('click', function (event) {
        if (!mobileQuery.matches) return;

        event.preventDefault();

        const column = toggle.closest('.edme-footer__column');
        if (!column) return;

        const isOpen = column.classList.contains('is-open');

        closeAllColumns();

        if (!isOpen) {
          openColumn(column, toggle);
        }
      });
    });

    syncAccordionMode();

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncAccordionMode);
    } else {
      mobileQuery.addListener(syncAccordionMode);
    }
  }

  function initAllEdmeFooters() {
    document.querySelectorAll('.edme-footer').forEach(initEdmeFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllEdmeFooters);
  } else {
    initAllEdmeFooters();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target;

    if (!section || !section.querySelectorAll) return;

    section.querySelectorAll('.edme-footer').forEach((footer) => {
      footer.dataset.edmeFooterInit = 'false';
      initEdmeFooter(footer);
    });
  });
})();